import React, { useState, useEffect } from "react"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"

import "./collapse-menu.scss"

const CollapseMenu = ({ options, slug }) => {
  const [activeCollapse, setActiveCollapse] = useState(0)
  useEffect(() => {
    if (window.location.hash === "#points") {
      setActiveCollapse(13)
      window.scrollTo(0, document.body.scrollHeight)
    }
  }, [])

  return (
    <div
      className={
        "f-legal-collapse-container " +
        (slug === "terminos-y-condiciones" ? "f-with-girl" : "")
      }
    >
      <ul className="f-list-collapse">
        {options.map((option, index) => {
          return (
            <li
              className="f-item-collapse"
              key={index}
              onClick={
                activeCollapse === index
                  ? () => setActiveCollapse(-1)
                  : () => setActiveCollapse(index)
              }
            >
              <div className="f-collapse-title-container">
                <h2
                  className={
                    "f-collapse-title " +
                    (activeCollapse === index ? "f-title-pink" : "")
                  }
                >
                  {option.tituloPrincipal}
                </h2>

                {activeCollapse === index ? (
                  <span>
                    <span className="f-icon-less" />
                  </span>
                ) : (
                  <span className="f-icon icon2-close f-icon-close" />
                )}
              </div>
              <div
                className={
                  "f-collapse-description-container " +
                  (activeCollapse === index ? "f-collapse-active" : "")
                }
                onClick={e => e.stopPropagation()}
              >
                <div
                  className={
                    "f-collapse-position-container " +
                    (activeCollapse === index ? "f-active" : "")
                  }
                >
                  {documentToReactComponents(option.descripcion.json)}
                </div>
                {option.tituloPrincipal === "k) Cookies" && (
                  <div className="f-collapse-container-cookies">
                    <div id="ot-sdk-cookie-policy"></div>
                    <button id="ot-sdk-btn" class="ot-sdk-show-settings">
                      Gestionar las cookies
                    </button>
                  </div>
                )}
              </div>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default CollapseMenu
